import { useMemo, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import ban from '~/assets/icons/ban.svg';
import call from '~/assets/icons/call.svg';
import dots from '~/assets/icons/dots.svg';
import minusRound from '~/assets/icons/minus_round.svg';
import sendMessage from '~/assets/icons/send_message.svg';
import { playSound, Sound } from '~/assets/sounds';
import { AppMessageMessage, MessageType } from '../AppMessageMessage';
import { DropdownMenu, IDropdownMenuItem } from '../DropdownMenu';
import { TextLabel } from '../TextLabel';
import {
	StyledButton,
	StyledDropdownWrapper,
	StyledHeadContainer,
	StyledImage,
	StyledImageButton,
	StyledInput,
	StyledMessagesContainer,
	StyledNewMessagesContainer,
	StyledPlayerInfoContainer,
	StyledPlayerNameContainer,
	StyledSendContainer,
} from './AppMessageDialog.styled';

const AppMessageDialog = () => {
	const [dropdownVisible, setDropdownVisible] = useState(false);
	const [inputValue, setInputValue] = useState('');

	const dropDownMenuItems: IDropdownMenuItem[] = useMemo(
		() => [
			{
				title: 'Позвонить',
				icon: call,
				onClick: () => console.log('--call'),
			},
			{
				title: 'Удалить из друзей',
				icon: minusRound,
				onClick: () => console.log('--remove'),
			},
			{
				title: 'Заблокировать',
				icon: ban,
				onClick: () => console.log('--ban'),
			},
		],
		[],
	);

	const buttonActive = useMemo(() => inputValue.length > 0, [inputValue]);

	return (
		<div>
			<StyledHeadContainer>
				<StyledPlayerInfoContainer>
					<StyledImage $online />
					<StyledPlayerNameContainer>
						<TextLabel className={'name'}>stdian</TextLabel>
						<TextLabel className={'online_info'}>
							игрок сейчас <span className={'online'}>Онлайн</span>
						</TextLabel>
					</StyledPlayerNameContainer>
				</StyledPlayerInfoContainer>
				<StyledImageButton
					src={dots}
					width={20}
					height={20}
					onClick={() => {
						setDropdownVisible(true);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
				<CSSTransition
					in={dropdownVisible}
					timeout={300}
					classNames={'menu'}
					unmountOnExit
				>
					<StyledDropdownWrapper>
						<DropdownMenu
							items={dropDownMenuItems}
							closeHandler={() => {
								setDropdownVisible(false);
								playSound(Sound.ClickButton);
							}}
						/>
					</StyledDropdownWrapper>
				</CSSTransition>
			</StyledHeadContainer>
			<StyledMessagesContainer>
				<AppMessageMessage
					type={MessageType.Incoming}
					player={'stdian'}
					time={'12:22'}
					text={'Пиздец, чо...'}
					online
				/>
				<AppMessageMessage
					type={MessageType.Outgoing}
					player={'stdian'}
					time={'12:22'}
					text={'Пиздец, чо...'}
					online={false}
				/>
				<AppMessageMessage
					type={MessageType.Incoming}
					player={'stdian'}
					time={'12:22'}
					text={
						'Привет, ну как там дела? Когда уже релиз то будет у нас на сервере, а то уже заебался ждать когда он блять произойдёт'
					}
					online
				/>
				<AppMessageMessage
					type={MessageType.Incoming}
					player={'stdian'}
					time={'12:22'}
					text={
						'Привет, ну как там дела? Когда уже релиз то будет у нас на сервере, а то уже заебался ждать когда он блять произойдёт'
					}
					online={false}
				/>
				<AppMessageMessage
					type={MessageType.Outgoing}
					player={'stdian'}
					time={'12:22'}
					text={
						'Привет, ну как там дела? Когда уже релиз то будет у нас на сервере, а то уже заебался ждать когда он блять произойдёт'
					}
					online={false}
				/>
				<StyledNewMessagesContainer>
					<TextLabel>НОВЫЕ СООБЩЕНИЯ</TextLabel>
				</StyledNewMessagesContainer>
				<AppMessageMessage
					type={MessageType.Outgoing}
					player={'stdian'}
					time={'12:22'}
					text={
						'Привет, ну как там дела? Когда уже релиз то будет у нас на сервере, а то уже заебался ждать когда он блять произойдёт'
					}
					online={false}
				/>
				<AppMessageMessage
					type={MessageType.Incoming}
					player={'stdian'}
					time={'12:22'}
					text={
						'Привет, ну как там дела? Когда уже релиз то будет у нас на сервере, а то уже заебался ждать когда он блять произойдёт'
					}
					online={false}
				/>
				<StyledSendContainer>
					<StyledInput
						placeholder={'Напишите сообщение...'}
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					/>
					<StyledButton
						$active={buttonActive}
						onMouseEnter={() => {
							if (buttonActive) {
								playSound(Sound.LinkCursor);
							}
						}}
						onClick={() => {
							if (buttonActive) {
								playSound(Sound.ClickButton);
							}
						}}
					>
						<img src={sendMessage} />
						<TextLabel>Отправить</TextLabel>
					</StyledButton>
				</StyledSendContainer>
			</StyledMessagesContainer>
		</div>
	);
};

export { AppMessageDialog };
